// extracted by mini-css-extract-plugin
module.exports = {"title":"mainHeader-module--title--ZehZp","wrapper":"mainHeader-module--wrapper--1FOSS","image":"mainHeader-module--image--1fALV"};